//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { between } from './utils'

export default {
  props: {
    range: {
      type: Number,
      required: true,
    },
    minSelected: {
      type: Number,
      required: true,
    },
    maxSelected: {
      type: Number,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    maxCount() {
      return Math.max(...this.items)
    },
    itemsPercentage() {
      return this.items.map((item, index) => {
        const min = this.range * index
        const max = this.range * (index + 1)

        return {
          inRange: between({
            min,
            max,
            minSelected: this.minSelected,
            maxSelected: this.maxSelected,
          }),
          height: Math.ceil((item / this.maxCount) * 100),
        }
      })
    },
  },
}
